import React, { PropTypes, Component } from 'react';

import SchedulingReports from '../SchedulingReports';

import { getLegacyReports, getTotalSchedulingReports } from '../selector';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../actions';

class LegacyReports extends Component {
  componentWillMount() {
    // pass current roleId. If not available the api fetches details of default role id
    const fetchParams = sessionStorage.getItem('roleId')
      ? { roleId: sessionStorage.getItem('roleId') }
      : {};
    this.props.actions.fetchReports(fetchParams);
  }

  render() {
    const { filteredReports, total, actions } = this.props;

    return (
      <SchedulingReports
        exportReport={actions.exportReport}
        total={total}
        category="legacy"
        reports={filteredReports}
      />
    );
  }
}

LegacyReports.propTypes = {
  fetchingReports: PropTypes.bool,
  total: PropTypes.object,
  filteredReports: PropTypes.array,
  actions: PropTypes.object
};

const mapStateToProps = state => {
  const { fetchingReports } = state.reports;
  const filteredReports = getLegacyReports(state);
  const total = getTotalSchedulingReports(state);

  return { fetchingReports, filteredReports, total };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LegacyReports);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/legacy-reports/LegacyReports.js